import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LorenDatePipe} from './pipes/loren-date.pipe';


@NgModule({
    declarations: [
        LorenDatePipe
    ],
    exports: [
        LorenDatePipe
    ],
    imports: [
        CommonModule
    ]
})
export class LorenDateModule {
}
